export const TemplateGoals: Record<string, string> = {
  "LOSE_WEIGHT": "לרדת במשקל",
  "GAIN_MUSCLE": "עליה במסת שריר",
  "HEALTHY_LIFESTYLE": "סגנון חיים בריא",
  "IMPROVE_FITNESS": "שיפור כושר",
}
